module.exports = __webpack_public_path__ + "static/img/logo.a5e8fe6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/logo.svg
// module id = GFCr
// module chunks = 1